module.exports = __webpack_public_path__ + "img/514aaf112093bf961d4e3c6437ecb5c9.514aaf11.png";